import {
  AccountType,
  InternalAccountTypes,
  SuperAdminAccountTypes,
} from '@ll-platform/frontend/core/auth/types';

export function isUserInternal(
  user?: { accountType?: AccountType },
  includeFreelancer = true,
) {
  const isInternalUser =
    user?.accountType && InternalAccountTypes.includes(user.accountType);
  if (!includeFreelancer) {
    return isInternalUser && user.accountType !== AccountType.Freelancer;
  }
  return isInternalUser;
}

export function isUserSuperAdmin(user?: { accountType?: AccountType }) {
  return user?.accountType && SuperAdminAccountTypes.includes(user.accountType);
}
